import graphql from "babel-plugin-relay/macro";

const StockSearchQuery = graphql`
query StockSearchQuery(
    $name_Icontains: String 
){
  politicianFilter(
    name_Icontains: $name_Icontains 
  ){
    edges{
      node{       
         id
        name
        party{
          partyName
        }
      
         
        upcomingStocks
      }
    }
  }
}
`

export default StockSearchQuery
// stockOwnedCount
//  price
//         priceDiff